import { Box, CircularProgress, Typography } from "@material-ui/core";

const LoadingComponent = () => {
  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress size={100} style={{ color: "#FFFFFF" }} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="body1">{`Loading...`}</Typography>
      </Box>
    </Box>
  );
};

export default LoadingComponent;
